import React, { PropsWithChildren } from "react";
import { TrademarkProvider as TrademarkContextProvider } from "@cp/entities/trademark";
import { Logo } from '#shared/ui/logo';

export const TrademarkProvider = (props: PropsWithChildren) => <TrademarkContextProvider value={Logo}>{props.children}</TrademarkContextProvider>